/** Minimal user shape for studio scope helpers (login / GET /studios payload). */
export type StudioScopeUser = { studios?: { id: string }[] } | null | undefined;

/** Aggregate "All Studios" is valid only when the user has two or more accessible studios (API §1.10). */
export function canUseAllStudiosScope(user: StudioScopeUser): boolean {
  return (user?.studios ?? []).length >= 2;
}

/**
 * Returns a studio id safe for API headers and PUT /users/me/studio-context.
 * Maps invalid or ineligible `"all"` to the first studio; keeps eligible `"all"`.
 */
export function normalizeStudioScopeForUser(
  storedId: string,
  user: StudioScopeUser,
  serverCurrentStudioId?: string | null,
): string {
  const studios = user?.studios ?? [];
  if (studios.length === 0) {
    return storedId === "all" ? "all" : storedId;
  }

  if (storedId === "all") {
    return canUseAllStudiosScope(user) ? "all" : studios[0]!.id;
  }

  if (studios.some((s) => s.id === storedId)) {
    return storedId;
  }

  if (serverCurrentStudioId && studios.some((s) => s.id === serverCurrentStudioId)) {
    return serverCurrentStudioId;
  }

  return canUseAllStudiosScope(user) ? "all" : studios[0]!.id;
}

export function isStudioContextApiErrorCode(code: string | undefined): boolean {
  return code === "STUDIO_CONTEXT_REQUIRED" || code === "VALIDATION_ERROR";
}
